import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const recordSession = async (walletAddress) => {
  try {
    const res = await api.post("/sessions", {
      wallet_address: walletAddress || null,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    });
    return res.data?.id || null;
  } catch (e) {
    // non-fatal
    console.warn("Failed to record session:", e?.message);
    return null;
  }
};

export const sendHeartbeat = async (sessionId, seconds) => {
  if (!sessionId) return;
  try {
    await api.post(`/sessions/${sessionId}/heartbeat`, { seconds });
  } catch (e) {
    // non-fatal
  }
};

export const adminLogin = async (password) => {
  const res = await api.post("/admin/login", { password });
  return res.data;
};

export const fetchAdminStats = async (password) => {
  const res = await api.get("/admin/stats", {
    headers: { "X-Admin-Password": password },
  });
  return res.data;
};
